import { Link } from "react-router-dom";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <section data-testid="faq-page" className="px-6 md:px-12 pt-36 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-24">
        <div>
          <Reveal className="lg:sticky lg:top-32">
            <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">Questions</span>
            <h1 className="mt-5 text-5xl sm:text-6xl tracking-tighter font-light leading-none text-[#1C1917]">FAQ</h1>
            <p className="mt-8 text-lg text-[#44403C] leading-relaxed font-light">
              Everything you need to know about staying with Masaya. Still have a question?
            </p>
            <Link data-testid="faq-contact-link" to="/contact" className="mt-6 inline-flex rounded-full bg-[#1C1917] text-white px-8 py-3.5 hover:bg-[#44403C] transition-colors duration-300 font-medium text-sm">
              Contact us
            </Link>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E7E5E4]">
                <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left text-lg font-normal tracking-tight text-[#1C1917] py-6 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#44403C] leading-relaxed font-light pb-6 pr-8 whitespace-pre-line">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div data-testid="faq-cta" className="mt-12 rounded-2xl border border-[#E7E5E4] bg-[#F7F6F2] px-8 py-10 text-center">
            <p className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">Ready when you are</p>
            <h2 className="mt-3 text-base md:text-lg font-light tracking-tight text-[#1C1917]">Find your furnished home in Austin</h2>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link data-testid="faq-book-btn" to="/book" className="inline-flex justify-center rounded-full bg-[#8A9A86] text-white px-8 py-3.5 hover:bg-[#77876F] transition-colors duration-300 font-medium text-sm w-full sm:w-auto">
                Book Your Stay
              </Link>
              <Link data-testid="faq-browse-btn" to="/properties" className="inline-flex justify-center rounded-full border border-[#1C1917] text-[#1C1917] px-8 py-3.5 hover:bg-[#1C1917] hover:text-white transition-colors duration-300 font-medium text-sm w-full sm:w-auto">
                Browse Accommodations
              </Link>
            </div>
            <p className="mt-6 text-sm text-[#44403C] font-light">
              Still have a question?{" "}
              <Link data-testid="faq-message-us-link" to="/contact" className="font-medium text-[#8A9A86] underline underline-offset-4 decoration-[#8A9A86]/40 hover:text-[#77876F] hover:decoration-[#77876F] transition-colors duration-300">
                Message us
              </Link>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
